import {
  customerGroupSchema,
  CustomerGroupType,
} from "@redotech/redo-model/customers/customer-group-definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const fetchTeamSegments = {
  name: "fetchTeamSegments" as const,
  input: z.object({
    segmentType: createEnum(CustomerGroupType).optional(),
    searchText: z.string().optional(),
    page: z.number().int().min(1).optional(),
    pageSize: z.number().int().min(1).max(100).optional(),
  }),
  output: z.object({
    segments: z.array(customerGroupSchema),
    totalCount: z.number().int().min(0),
  }),
};
